__turbopack_context__.v({
  "tile": "ProductTile-module-scss-module__Sqcbmq__tile",
});
